import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';
import { QueryKey } from '@/Config/api/queryKey';
import { CsatAnalyticsDto } from '@/Domain/api/Analytics/dto/CsatAnalytics.dto';
import { TtfrAnalyticsDto } from '@/Domain/api/Analytics/dto/TtfrAnalytics.dto';

type DateRange = {
  startDate: Date;
  endDate: Date;
};

const toISODate = (date: Date) => format(date, 'yyyy-MM-dd');

export const useHandoffAnalytics = (range: DateRange) => {
  const start = toISODate(range.startDate);
  const end = toISODate(range.endDate);

  const csatQuery = useQuery<CsatAnalyticsDto>({
    queryKey: [QueryKey.analytics.externalCsat, { start, end }],
  });

  const ttfrQuery = useQuery<TtfrAnalyticsDto>({
    queryKey: [QueryKey.analytics.ttfr, { start, end }],
  });

  return {
    csatData: csatQuery.data,
    isCsatLoading: csatQuery.isLoading,
    isCsatError: csatQuery.isError,
    ttfrData: ttfrQuery.data,
    isTtfrLoading: ttfrQuery.isLoading,
    isTtfrError: ttfrQuery.isError,
  };
};
